import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { get, patch } from './api.ts'
import { adoptAccountLang } from './i18n.ts'
import type { CondoInfo, Me } from './types.ts'

export function useMe() {
  const q = useQuery({ queryKey: ['me'], queryFn: () => get<Me>('/api/me'), staleTime: 60_000 })
  const locale = q.data?.user?.locale
  // ADR 0040: a browser that never chose follows the account; one that chose tells the account.
  useEffect(() => adoptAccountLang(locale, (next) => void patch('/api/me', { locale: next }).catch(() => undefined)), [locale])
  return q
}

export function useCondo(slug: string) {
  const me = useMe()
  const membership = me.data?.memberships.find((m) => m.slug === slug)
  const info = useQuery({
    queryKey: ['condo', membership?.condoId],
    queryFn: () => get<CondoInfo>(`/api/condos/${membership!.condoId}`),
    enabled: Boolean(membership),
    staleTime: 60_000,
  })
  return { me, membership, info, condoId: membership?.condoId ?? '', can: (cap: string) => Boolean(info.data?.me.capabilities.includes(cap)) }
}
